import type * as React from 'react';

function SvgGraph(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 16 14" width="1em" {...props}>
      <path
        d="M.617 0c.34 0 .616.276.616.617V12.69h14.121a.646.646 0 01.637.655.662.662 0 01-.662.654H.617A.627.627 0 010 13.355V.617C0 .277.276 0 .617 0zM14.8 1.309c.188-.072.377.09.377.286l-.12 3.048a.273.273 0 01-.446.215l-.822-.645-1.01 1.38a.677.677 0 01-.514.269l-2.639.018-1.353 2.724a.687.687 0 01-.6.359L4.986 8.89l-1.114 2.26c-.086.18-.309.25-.497.161l-.497-.269c-.171-.107-.24-.34-.154-.484l1.285-2.635a.668.668 0 01.6-.376l2.689.071L8.65 4.894c.103-.215.325-.377.565-.359l2.707-.036.822-1.111-.788-.61c-.171-.143-.137-.448.086-.52z"
        fill="#00182E"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgGraph;
